module.exports = __webpack_public_path__ + "img/ico-calendario.b30b9656.svg";